module.exports = __webpack_public_path__ + "img/icdeposit.4041f0b9.png";